var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBcheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33203,
    y: 3.33337,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    fill: "#212129"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6654 27.6667L29.4154 15.9167L27.082 13.5834L17.6654 23L12.9154 18.25L10.582 20.5834L17.6654 27.6667ZM19.9987 36.6667C17.6931 36.6667 15.5265 36.2292 13.4987 35.3542C11.4709 34.4792 9.70703 33.2917 8.20703 31.7917C6.70703 30.2917 5.51953 28.5278 4.64453 26.5C3.76953 24.4723 3.33203 22.3056 3.33203 20C3.33203 17.6945 3.76953 15.5278 4.64453 13.5C5.51953 11.4723 6.70703 9.70837 8.20703 8.20837C9.70703 6.70837 11.4709 5.52087 13.4987 4.64587C15.5265 3.77087 17.6931 3.33337 19.9987 3.33337C22.3043 3.33337 24.4709 3.77087 26.4987 4.64587C28.5265 5.52087 30.2904 6.70837 31.7904 8.20837C33.2904 9.70837 34.4779 11.4723 35.3529 13.5C36.2279 15.5278 36.6654 17.6945 36.6654 20C36.6654 22.3056 36.2279 24.4723 35.3529 26.5C34.4779 28.5278 33.2904 30.2917 31.7904 31.7917C30.2904 33.2917 28.5265 34.4792 26.4987 35.3542C24.4709 36.2292 22.3043 36.6667 19.9987 36.6667Z",
    fill: "#E1FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcheckIcon);
export default __webpack_public_path__ + "static/media/bcheckIcon.10ff99590a7efa2249538cde327969a3.svg";
export { ForwardRef as ReactComponent };